module.exports = __webpack_public_path__ + "img/file_word.4ecfb617.svg";